import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Product } from '../../order/models/product';
import { Order } from '../../order/models/order';
import { GiftCard } from '../models/giftcard';


@Injectable()
export class GiftCardService {

  constructor() { }

  getGiftCardAvailableAmount(orderNumber: number, giftCardNumber: string, orderAmount: number): Observable<number> {
    return of();
  }

  getGuestGiftCardAvailableAmount(orderNumber: number, giftCardNumber: string, orderAmount: number): Observable<number> {
    return of();
  }

  applyOrderGiftCardPayments(orderNumber: number, giftCardRedeems: GiftCard[]): Observable<GiftCard[]> {
    return of();
  }

  refundGiftCards(orderNumber: number, giftCards: GiftCard[]): Observable<GiftCard[]> {
    return of();
  }

  recalculateGiftCardAmount(orderNumber: number, giftCardNumbers: string[], orderAmount: number): Observable<GiftCard[]> {
    return of();
  }

  guestRecalculateGiftCardAmount(orderNumber: number, giftCardNumbers: string[], orderAmount: number): Observable<GiftCard[]> {
    return of();
  }
}
